import { v4 as uuid } from "uuid";
import store from "@/redux/store";

import i18n from "i18next";
//import LanguageDetector from "i18next-browser-languagedetector";
//import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import HttpApi from 'i18next-http-backend';
import nl from '@/locales/nl.json'
import CookieHelper from "helpers/cookie";
import { startTransition } from 'react';

const fallbackLng = ["nl"];

const getAPIHeader =() => {
var tabID = sessionStorage.tabID && 
            sessionStorage.closedLastTab !== '2' ? 
            sessionStorage.tabID : 
            sessionStorage.tabID = uuid().slice(0, 8);
sessionStorage.closedLastTab = '2';

    let headers = {
      Accept: "application/json; charset=UTF-8",
      tabid: tabID
    };
    let rawCookie = CookieHelper.getCookie("ppc_obj");
 
    if(typeof rawCookie != 'undefined' && rawCookie != "") {
        try {
        let tokenObj = JSON.parse(rawCookie);
        if (tokenObj && tokenObj.token) {
            let token = tokenObj.token;
            headers.Authorization = `Bearer ${token}`;
        }
        if (tokenObj && tokenObj.uuid) {
            let tokenuuid = tokenObj.uuid;
            headers.cauth = `${tokenuuid}`;
        }
            } catch {
                
        }

        try {
        let reduxStoreStates = store.getState();
        let tenantId = reduxStoreStates.AuthReducer.tenant.key;
        let userId = reduxStoreStates.AuthReducer.user.key;
        if(userId) {
            headers.user = userId;
        }
        if(tenantId) {
            headers.tenant = tenantId;
        }
            } catch {
                
        }
        }
        return headers;
    
};

const resources = {
   nl: {
     translation: nl
   },
   de: {
     translation: nl
   }
 };

class i18NBase {
init = () => {
    let api_url = process.env.REACT_APP_API_ENDPOINT;
    i18n
      //.use(Backend) // used to load data from othe directory
      //.use(LanguageDetector) // detects the current language
      .use(initReactI18next) // passes i18n down to react-i18next
      .use(HttpApi)
      .init({
          partialBundledLanguages: true,
        fallbackLng, // default language
    //    detection: {
    //      checkWhitelist: true,
    //    },
        debug: false,
        lng: 'nl',
         backend: {
               customHeaders: getAPIHeader(),
             overrideMimeType: true,
        loadPath: api_url+'language',
         parse: function(data) { 
             let lang = JSON.parse(data);
            return lang.data; },
          crossDomain: true,
        },    
      }), (err, t) => {
          
          };
      };
      
};
export default new i18NBase();